<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  metrics(period) {
    return axios.get('admin/dashboard', { params: { period }, ...AS.getDefaultHeaders() });
  },
};
</script>
